import { StoreConstants, LockModel, ErrorModel } from '@/types';
import { ListMaintenanceState } from '@/types/store/configuration/listMaintenance';
import { MutationTree } from 'vuex';

const ListMaintenance = StoreConstants.ListMaintenance;

export const mutations: MutationTree<ListMaintenanceState> = {
  [ListMaintenance.Mutations.SetExtendingListLock](state, payload: boolean) {
    state.extendingLock = payload;
  },
  [ListMaintenance.Mutations.ExtendListLock](state, payload: LockModel) {
    state.builtInListLock = payload;
  },
  [ListMaintenance.Mutations.ExpireListLock](state, payload: any) {
    if (payload) {
      state.errorMessage = payload;
    }
    state.builtInListLock = {} as LockModel;
  },
  [ListMaintenance.Mutations.SetComponentName](state, payload: string) {
    state.componentName = payload;
  },
  [ListMaintenance.Mutations.SetErrorModel](state, payload: ErrorModel) {
    state.errorModel = payload;
  },
  [ListMaintenance.Mutations.SetEntityLock](state, payload: LockModel) {
    state.builtInListLock = payload;
  }
};
